import { SignIn } from '@clerk/clerk-react';
import { useTranslation } from 'react-i18next';
import { useClerkGate } from '@/hooks/useClerkGate';
import { BootFrame } from '@/features/auth/BootFrame';
import { postSignInUrl } from '@/features/auth/return-path';

/**
 * Unauthenticated sign-in screen.
 *
 * Wraps Clerk's <SignIn> in the shared {@link BootFrame} (Aelo mark + localized
 * headline/subtitle). The Clerk appearance + social-first layout come from the
 * ClerkProvider `appearance` (see lib/clerk-theme.ts); the actual sign-in
 * strategy (passwordless / OAuth) is controlled in the Clerk Dashboard.
 */
export function SignInScreen() {
  const { t } = useTranslation('auth');
  // Пока поднимается clerk-js, форма — пустой контейнер: ход за нами, и
  // без полосы это выглядит как замерший экран с одним заголовком.
  const { isLoaded } = useClerkGate();

  return (
    <BootFrame
      headline={t('auth.signInHeadline')}
      subtitle={t('auth.signInSubtitle')}
      busy={!isLoaded}
    >
      {/* Hide Clerk's built-in header — the branded block in BootFrame already
          shows the mark + headline + subtitle, so Clerk's own "Sign in to Aelo"
          title would duplicate it. Scoped here, not in the shared clerk-theme,
          so user-profile keeps its header. */}
      <SignIn
        routing="hash"
        forceRedirectUrl={postSignInUrl(window.location)}
        appearance={{ elements: { header: { display: 'none' } } }}
      />
    </BootFrame>
  );
}
